import { leadStoreGenerator } from '../lead-store';
export var createLead = function (origin) {
    var leadStore = leadStoreGenerator();
    if (!Object.keys(leadStore).includes(origin)) {
        throw new Error("Invalid origin of ".concat(origin, " provided. This lead origin is not supported by this library."));
    }
    return new leadStore[origin](origin);
};
//# sourceMappingURL=index.js.map